import React, { Dispatch, useEffect } from 'react'
import { useWebsiteLazyQuery } from '../../../__generated__/graphql'
import CreatePositionStepper from './CreatePositionStepper'
import { useWebsiteIdFinder } from '../../../utils/hooks/website/useWebsiteIdFinder'
import Loader from '../../../components/loader/Loader'

export const CreatePositionWizzardFromSidebar: React.FC<{
  updateSidebarItems: () => void
  setOpen: Dispatch<React.SetStateAction<boolean>>
  websiteId?: string | number | null
}> = ({ updateSidebarItems, setOpen, websiteId: websiteIdProp }) => {
  const [getWebsiteData, { data: websiteData, loading }] = useWebsiteLazyQuery()
  const websiteIdFromRoute = useWebsiteIdFinder()
  const websiteId = websiteIdProp ?? websiteIdFromRoute

  useEffect(() => {
    if (websiteId) getWebsiteData({ variables: { id: websiteId } })
  }, [websiteId, getWebsiteData])

  if (!websiteId) {
    return <CreatePositionStepper onSuccess={updateSidebarItems} setOpen={setOpen} />
  }

  if (loading || !websiteData?.website) return <Loader />
  return <CreatePositionStepper website={websiteData.website} onSuccess={updateSidebarItems} setOpen={setOpen} />
}

export default CreatePositionWizzardFromSidebar
